














import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Badge from "@/components/Badge.vue";
import { NavigationMenu, OrderStatus } from "../types/enum/OrderEnum";
import { IOrderPaging } from "../types/interface/IOrderDto";
import { getOrderStatusForRequestOrderList } from "../libs/utils";

@Component({
  name: "bottom-navigation",
  components: {
    Badge
  }
})
export default class Home extends Vue {
  @Getter("tabIndex") tabIndex!: number;
  @Getter("unreadMessageCount") unreadMessageCount!: number;
  @Prop(Array) navigationItem!: INavigationItem[];
  @Prop(Function) onBottonNavChange!: Function;

  @Watch("index")
  onChange(val: number, old: number) {
    if (val === old) {
      return;
    }
    this.$store.commit("handleClearOrderList");
    this.$store.commit("handleKeyword", "");
    this.$store.commit("handleCurrentMessagePage", 1);
    if (this.index === NavigationMenu.Orders) {
      this.$store.dispatch("handleOrderList", {
        page: 1,
        orderStatus: getOrderStatusForRequestOrderList("Processing"),
        ExcludePreOrderStatuses: [
          OrderStatus.Processing,
          OrderStatus.Ready,
          OrderStatus.Delivering
        ]
      });
      this.$store.commit("handleCurrentOrderTab", "Processing");
      this.$store.commit("handleCurrentOrderPage", 1);
    }
    this.onBottonNavChange(val);
  }

  @Mutation("handleTabIndex")
  handleTabIndex: Function;

  public get index(): NavigationMenu {
    return this.tabIndex;
  }

  public set index(v: NavigationMenu) {
    this.handleTabIndex(v);
  }

  isShowBadge(item: any): boolean {
    return item.showBadge && this.unreadMessageCount > 0;
  }
}

export interface INavigationItem {
  text: string;
  icon: string;
  showBadge: boolean;
}
